export default __webpack_public_path__ + "static/media/newsletter.5dc1f3c5.pdf";